import client from './axios'

export async function upgradeEntryPoll(entryId: number): Promise<number> {
  const { data } = await client.put<{ entry_id: number }>(
    `/entry/${entryId}/upgrade-poll`,
  )

  return data.entry_id
}
